module.exports = 'auto=compress,format';
